import { AnyAction } from 'redux';

const initialState = {};

export type LoadingState = {
  [key: string]: {
    isInFlight: boolean;
  };
};

const loadingReducer = (
  state: LoadingState = initialState,
  action: AnyAction,
) => {
  const { type } = action;
  const matches = /(.*)_(REQUEST_MADE|REQUEST_SUCCESS|REQUEST_ERROR)/.exec(
    type,
  );

  if (!matches) {
    return state;
  }

  const requestName = matches[1];
  const requestState = matches[2];

  return {
    ...state,
    [requestName]: {
      isInFlight: requestState === 'REQUEST_MADE',
      isError: requestState === 'REQUEST_ERROR',
      isSuccess: requestState === 'REQUEST_SUCCESS',
    },
  };
};

export default loadingReducer;
